import { Form, FormBlocker, FormItemLabel } from '@extend/antd/form';
import { CommonNotificationSaveError } from '@shares/CommonNotification';
import { O2OFormItem } from '@shares/O2OFormItem';
import { Button, Col, Input, Row, Select, Typography } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { JsonEditor as Editor } from 'jsoneditor-react';
import { TypeOrganization } from 'o2o_layout/lib/common/model';
import { useEffect, useRef } from 'react';
import useGetSuggestionSegment from '../hooks/GetSugesstionSegment';
import useUpdateSugesstionSegment from '../hooks/UpdateSuggestionSegment';
import React from 'react';

type TProps = FormComponentProps & {
  company?: TypeOrganization
};

const SegmentSuggestionSetting = Form.create<TProps>()((props: TProps) => {
  const editorRef = useRef<any>(null);

  const { getFieldDecorator, getFieldValue, setFields, validateFields } = props.form;

  const detail = useGetSuggestionSegment();
  const update = useUpdateSugesstionSegment();

  useEffect(() => {
    if (editorRef.current?.jsonEditor) editorRef.current.jsonEditor.set(detail?.response?.result.suggestDetail || []);
    setFields({ suggestDetail: { value: detail?.response?.result.suggestDetail, touched: true } });
  }, [detail?.response?.result.suggestDetail]);

  useEffect(() => {
    if (props.company?.id && getFieldValue('suggestionType') && getFieldValue('suggestionType') !== detail.dto?.suggestionType)
      detail.handleGetSuggestionSegment({
        orgId: props.company?.id,
        suggestionType: getFieldValue('suggestionType'),
      });
  }, [getFieldValue('suggestionType'), props.company?.id]);

  const validateJSON = (data: unknown): any[] | null => {
    try {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;

      if (!Array.isArray(parsed)) {
        CommonNotificationSaveError('JSON_IS_NOT_ARRAY');
        return null;
      }

      return parsed as any[];
    } catch {
      CommonNotificationSaveError('Something went wrong!');
      return null;
    }
  };

  const onSaveChanges = async () => {
    validateFields(async (error: any, values: any) => {
      if (error) return;

      // Gọi hàm validate
      const validData = validateJSON(values.suggestDetail);

      // Nếu không phải mảng => dừng luôn, không gọi API
      if (!validData) return;

      const payload = {
        orgId: props.company?.id,
        suggestDetail:
          typeof values.suggestDetail === 'string' ? JSON.parse(values.suggestDetail) : values.suggestDetail,
        suggestionType: values.suggestionType,
      };

      const res = await update.handleUpdateSugesstionSegment(payload as any);
      if (res?.success) setTimeout(() => detail.onRetry(), 1000);
    });
  };

  return (
    <Form layout="vertical" hideRequiredMark colon={false}>
      <Row type="flex" gutter={[10, 10]}>
        <Col xs={24}>
          <Typography.Title level={4}>Segment Suggestion Setting</Typography.Title>
        </Col>
        <Col xs={24} md={28} lg={14} xl={8}>
          <O2OFormItem help="" label={<FormItemLabel text="Suggestion Type" requiredMark />}>
            {getFieldDecorator('suggestionType', {
              rules: [{ required: true }],
            })(
              <Select placeholder="Select suggestion type" showArrow allowClear>
                <Select.Option value={'big_segment_commendation'}>Big Segment Commendation</Select.Option>
              </Select>
            )}
          </O2OFormItem>
        </Col>

        <Col xs={24} className="pb0" style={{ paddingBottom: 0 }}>
          <FormItemLabel style={{ fontSize: 14, paddingBottom: 0 }} text="Configuration" requiredMark />
        </Col>

        <Col xs={24} md={20} lg={18} xl={16} className="mb10">
          <FormBlocker block={detail.isLoading || update.isLoading}>
            <Editor
              ref={editorRef}
              key={'editor'}
              modes={'code'}
              htmlElementProps={{ style: { height: 510 } }}
              style={{ minHeight: 600 }}
              height={600}
              value={getFieldValue('suggestDetail')}
              allowedModes={['code', 'form', 'text', 'tree', 'view', 'preview']}
              mode={'code'}
              onChangeText={(values: any) => {
                if (values) {
                  setFields({ suggestDetail: { value: values, touched: true } });
                } else {
                  props.form.setFieldsValue({ suggestDetail: undefined });
                }
              }}
            />
          </FormBlocker>
          {getFieldDecorator('suggestDetail', {
            initialValue: JSON.stringify({}),
          })(<Input.TextArea placeholder="Enter" rows={10} style={{ display: 'none' }} />)}
        </Col>

        <Col xs={24}>
          <Button type="primary" loading={update.isLoading || detail.isLoading} onClick={onSaveChanges}>
            Save
          </Button>
        </Col>
      </Row>
    </Form>
  );
});

export default SegmentSuggestionSetting;
